import React, { createContext, useState } from "react";

export const ConfiguratorContext = createContext();

const ConfiguratorContextProvider = (props) => {
  const [edittedFields, setEdittedFields] = useState([]);
  const [hasRetrievedConfig, setHasRetrievedConfig] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const applyFieldUpdate = (allFields, currentField) => {
    const existingFieldIndex = allFields.findIndex(
      (item) => item.key === currentField.key,
    );
    if (existingFieldIndex === -1) {
      return [...allFields, currentField];
    }
    return [
      ...allFields.slice(0, existingFieldIndex),
      {
        ...allFields[existingFieldIndex],
        value: currentField.value,
        modified: currentField.modified,
      },
      ...allFields.slice(existingFieldIndex + 1),
    ];
  };

  // These have to update functionally. Two settings written during the same commit
  // -- a fee option and a state fee max, say -- would otherwise both start from the
  // same stale array, so the second silently discarded the first and only one key
  // ever reached the publish payload.
  const addNewEdittedField = (field) => {
    setEdittedFields((allFields) => applyFieldUpdate(allFields, field));
  };

  const addBatchOfEdittedFields = (fields) => {
    setEdittedFields((allFields) => fields.reduce(applyFieldUpdate, allFields));
  };

  const clearEdittedFieldList = () => {
    setEdittedFields([]);
  };

  /**
   * Settings that can hold a malformed value report it here so the publish action can be
   * withheld. A setting is keyed by the config property it writes, so a component with
   * several inputs feeding one property reports a single error for that property.
   */
  const setValidationError = (key, hasError) => {
    setValidationErrors((currentErrors) => {
      if (!!currentErrors[key] === hasError) {
        return currentErrors;
      }
      const updatedErrors = { ...currentErrors };
      if (hasError) {
        updatedErrors[key] = true;
      } else {
        delete updatedErrors[key];
      }
      return updatedErrors;
    });
  };

  return (
    <ConfiguratorContext.Provider
      value={{
        edittedFields,
        hasRetrievedConfig,
        addNewEdittedField,
        addBatchOfEdittedFields,
        clearEdittedFieldList,
        setHasRetrievedConfig,
        setValidationError,
        hasValidationErrors: Object.keys(validationErrors).length > 0,
      }}
    >
      {props.children}
    </ConfiguratorContext.Provider>
  );
};

export default ConfiguratorContextProvider;
